/** @format */
import {Chart} from 'components/charts/multiline-chart/model/charts';

import {PointName} from 'components/charts/multiline-chart/model/common';

import {calcMetricForecast} from 'features/mediaplan-progress/helpers/calcMetricForecast';

import {ChartIds} from '../../models/chartIds';
import {injectForecastToChartData} from './injectForecastToChartData';
import {getPrimaryValuesList} from './getPrimaryValuesList';

interface Options {
  chart: Chart<ChartIds>;
  forecastPoints: PointName[];
  normalPoints: PointName[];
}

const addForecastToSimpleChart = ({
  chart,
  normalPoints,
  forecastPoints,
}: Options): Chart<ChartIds> => {
  // Собираем коллекцию значений по основному графику

  const primaryValuesList = getPrimaryValuesList(chart.chartsData, normalPoints);

  const isSecondary = chart.chartsData.some(data => data.secondary !== undefined);

  // Вычисляем прогнозы (накопительную линию считаем только если она есть на графике)

  const {primary, secondary} = calcMetricForecast({
    kind: 'additive',
    factDaily: primaryValuesList,
    forecastDays: forecastPoints,
    withSecondary: isSecondary,
  });

  // Записываем прогнозы в данные графика

  const newChartData = injectForecastToChartData({
    original: chart.chartsData,
    primaryForecast: primary,
    secondaryForecast: isSecondary ? (secondary ?? null) : null,
  });

  return {
    ...chart,
    chartsData: newChartData,
  };
};

export {addForecastToSimpleChart};
